import { z } from 'zod';

/** Os erros que a tela da corrida trata (spec §3.7). Os do backend chegam em
 *  `errors[].extensions.code`; `OUTSIDE_COVERAGE` e `UNKNOWN_OUTCOME` nascem no BFF. */
export const Taxi99ErrorCodeSchema = z.enum([
  'NO_CATEGORY_AVAILABLE',
  'INSUFFICIENT_BUDGET',
  'ESTIMATE_UNAVAILABLE',
  'INVALID_PHONE',
  'PHONE_REGISTRATION_FAILED',
  'WEBVIEW_UNAVAILABLE',
  'MOBILITY_ACCESS_BLOCKED',
  'HELP_CENTER_RIDE_NOT_FOUND',
  'OUTSIDE_COVERAGE',
  'UNKNOWN_OUTCOME',
  'UNKNOWN',
]);
export type Taxi99ErrorCode = z.infer<typeof Taxi99ErrorCodeSchema>;

/** Código do mobility-business-service → código da tela. `PHONE_MISMATCH` não
 *  acontece mais desde 31/08 e cai no mesmo tratamento do cadastro; `'9'` é o
 *  `MOBILITY_ACCESS_BLOCKED` (dia da semana bloqueado pela política Smart). */
const WIRE = new Map<string, Taxi99ErrorCode>([
  ['NO_CATEGORY_AVAILABLE', 'NO_CATEGORY_AVAILABLE'],
  ['INSUFFICIENT_BUDGET', 'INSUFFICIENT_BUDGET'],
  ['ESTIMATE_UNAVAILABLE', 'ESTIMATE_UNAVAILABLE'],
  ['INVALID_PHONE', 'INVALID_PHONE'],
  ['PHONE_REGISTRATION_FAILED', 'PHONE_REGISTRATION_FAILED'],
  ['PHONE_MISMATCH', 'PHONE_REGISTRATION_FAILED'],
  ['WEBVIEW_UNAVAILABLE', 'WEBVIEW_UNAVAILABLE'],
  ['9', 'MOBILITY_ACCESS_BLOCKED'],
  ['HELP_CENTER_RIDE_NOT_FOUND', 'HELP_CENTER_RIDE_NOT_FOUND'],
]);

/** O primeiro código conhecido, na ordem do backend (leia com `businessErrorCodes`
 *  do voll-apollo). Nunca pela `message`: seis chaves de tradução não existem no
 *  backend e a mensagem chega como a chave crua. */
export function toTaxi99ErrorCode(codes: readonly string[]): Taxi99ErrorCode {
  for (const code of codes) {
    const known = WIRE.get(code);
    if (known) return known;
  }
  return 'UNKNOWN';
}
